import { createContext, useContext } from 'react'

export type RightPanelRequest = { key: string; id: number } | null

export type RightPanelValue = {
  expanded: boolean
  toggle: () => void
  openModule: (key: string) => void
  request: RightPanelRequest
  unfoldedModules: ReadonlySet<string>
  toggleModule: (key: string) => void
  setNotification: (key: string, count: number) => void
}

const noop = () => {}

// Without a provider (tests, a module shown outside the page) the panel reads as open.
export const defaultRightPanel: RightPanelValue = {
  expanded: true,
  toggle: noop,
  openModule: noop,
  request: null,
  unfoldedModules: new Set(),
  toggleModule: noop,
  setNotification: noop,
}

export type HopTimusPanelMode = 'closed' | 'docked' | 'floating'

export type RightPanelHopTimusValue = {
  mode: HopTimusPanelMode
  afterFold: boolean
  focusRequest: number
  ask: () => void
  toggle: () => void
  close: () => void
  detach: () => void
  dock: () => void
}

export const defaultRightPanelHopTimus: RightPanelHopTimusValue = {
  mode: 'closed',
  afterFold: false,
  focusRequest: 0,
  ask: noop,
  toggle: noop,
  close: noop,
  detach: noop,
  dock: noop,
}

export const RightPanelContext = createContext<RightPanelValue>(defaultRightPanel)

export const RightPanelNotificationsContext = createContext<Record<string, number>>({})

export const RightPanelHopTimusContext = createContext<RightPanelHopTimusValue>(defaultRightPanelHopTimus)

export const useRightPanel = () => useContext(RightPanelContext)

export const useRightPanelHopTimus = () => useContext(RightPanelHopTimusContext)

export const useModuleNotificationCount = (moduleKey: string) =>
  useContext(RightPanelNotificationsContext)[moduleKey] ?? 0
